/**
 * Copyright (C) Mairistem
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 *
 * Proprietary and confidential
 */

// ⚠️ `import type` et non un import de valeur : ce module est réexporté par
// `constants/index.ts`, très largement importé, et charger réellement la lib
// casserait les tests qui n'en mockent qu'une partie.
import type { TypeComponent } from '@mairistem/administres-utils';

import type { TypeActe } from '@/types';

/**
 * Variante d'affichage des composants d'état civil de la lib (`EtatCivil`,
 * `ParentForm`) selon le type d'acte.
 *
 * Ce qu'elle change : le sens d'une filiation non renseignée — parent *décédé*
 * en naissance, *inconnu* en reconnaissance (le cas courant, l'acte étant
 * souvent fait par un seul parent).
 *
 * Valeurs en littéraux castés : l'enum n'est ici accessible qu'en `import type`.
 */
export const TYPE_COMPONENT_BY_TYPE_ACTE: Partial<
  Record<TypeActe, TypeComponent>
> = {
  naissance: 'NAISSANCE' as TypeComponent,
  reconnaissance: 'RECONNAISSANCE' as TypeComponent,
  /*
   * Décès : variante NAISSANCE, donc « parent DÉCÉDÉ » — le sens attendu.
   *
   * ⚠️ Dette : `ai_vivant` prend en base une TROISIÈME valeur, `'?'`, que l'IHM
   * binaire ne sait pas exprimer. Cet écran écrit `'N'` ou `'O'`, jamais `'?'`.
   */
  deces: 'NAISSANCE' as TypeComponent,
  // Mariage : même variante, et même dette sur la troisième valeur d'`ai_vivant`.
  mariage: 'NAISSANCE' as TypeComponent,
};

export default TYPE_COMPONENT_BY_TYPE_ACTE;
